import axios from '../../../axios';
import JobCloseReasonDTO from '../types/jobCloseReasonDTO';

export const getJobCloseReasons = () => axios.get(`jobsearch/api/close-job-reason`);
export const updateJobCloseReasons = (payload: JobCloseReasonDTO) =>
  axios.put('jobsearch/api/close-job-reason/', payload);
export const saveJobCloseReasons = (payload: JobCloseReasonDTO) =>
  axios.post('jobsearch/api/close-job-reason/', payload);
